<template>
  <div class="bd_y" v-if="show_body">
    <div class="top clearfix">
      <div class="top_left clearfix">
        <div class="rq">
          <span>{{user.num}}</span>
          <br>战略影响力
        </div>
        <div class="ry">
          <h1>{{user.nickname}}</h1>
          <h2>『个人战略课』传播大使</h2>
        </div>
      </div>
      <img :src="user.headimgurl" class="tx" />
      <div class="main_top clearfix">
        <ul class="clearfix">
          <li @click="switch_tab(1)" :class="{on: main_show==1}">
            <img v-if="main_show==1" src="@a/main33.png" />
            <img v-else src="@a/main3.png" />
            <p>传播力排行</p>
          </li>
          <li @click="switch_tab(3)" :class="{on: main_show==3}">
            <img v-if="main_show==3" src="@a/main11.png" />
            <img v-else src="@a/main1.png" />
            <p>影响力排行</p>
          </li>
          <li @click="switch_tab(2)" :class="{on: main_show==2}">
            <img v-if="main_show==2" src="@a/main44.png" />
            <img v-else src="@a/main4.png" />
            <p>我的影响力</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <div class="main_bottom" v-show="main_show==1 || main_show==3">
        <ul class="main_ranking">
          <li class="clearfix">
            <span class="rank_ll rank_me">
                {{user.key}}
              </span>
            <img :src="user.headimgurl" class="xtx" />
            <span class="rank_name">{{user.nickname}}</span>
            <span class="rank_right">
                已邀请 {{sort == 'num' ? user.num : user.buynum}} 人
              </span>
          </li>
          <li class="clearfix" v-for="(item,index) in list">
            <span class="rank_ll" v-show="index<3">
                <img src="https://themes-cdn.xjy.cn/statics/fission/images/xz1.png" v-show="index==0"/>
                <img src="https://themes-cdn.xjy.cn/statics/fission/images/xz2.png" v-show="index==1"/>
                <img src="https://themes-cdn.xjy.cn/statics/fission/images/xz3.png" v-show="index==2"/>
              </span>
            <span class="rank_ll" v-show="index>=3">
                {{index+1}}
              </span>
            <img :src="item.headimgurl" class="xtx" />
            <span class="rank_name">{{item.nickname}}</span>
            <span class="rank_right">
                已邀请 {{sort == 'num' ? item.num : item.buynum}} 人
              </span>
          </li>
        </ul>
      </div>
      <div class="main_bottom main_details" v-show="main_show==2">
      <h1>影响力收益</h1>
      <h2>¥ {{total}}</h2>
        <ul class="main_ranking">
         <li class="clearfix" v-for="(item,index) in share_list" :key="index">
            <span class="rank_ll">
                {{index+1}}
              </span>
            <img :src="item.headimgurl" class="xtx" />
            <span class="rank_name">{{item.nickname}}</span>
            <span class="rank_right">
                已付款
              </span>
          </li>
        </ul>
      </div>
      <p v-show="loading && has_more && main_show != 2" class="jc">加载中...</p>
    </div>
    <!-- 卡片弹出层 -->
    <van-popup v-model="card_show" class="pop_card">
      <img :src="imgUrl" alt="请稍等图片正在加载">
      <h3>长按上方图片保存分享好友或朋友圈</h3>
    </van-popup>
  </div>
</template>
<script>
import {
  fission_index
} from '@/api/other'
import {
  coursedetail
} from '@/api/course'
import {
  myshare
} from '@/api/person'
export default {
  data() {
      return {
        show_body: false,
        user: {},
        main_show: 1,
        list: [],
        loading: false,
        page: 0,
        limit: 10,
        sort: 'num',
        has_more: false,
        poster: '',
        card_show: false,
        imgUrl: "",
        total: "",
        share_list: []
      }
    },
    methods: {
      pullData() {
        let p1 = myshare();
        let p2 = fission_index({page: 0,sort: 'num'});
        Promise.all([p1, p2])
        .then((DL) => {
          // p2
          this.show_body = true;
          this.user = DL[1].user;
          this.list = DL[1].list;
          this.has_more = DL[1].list.length >= 10;
          // p1
          this.total = DL[0].total;
          this.share_list = DL[0].sharelist;
        })
      },
      switch_tab(main_show) {
        this.main_show = main_show;
        if (this.main_show == 1 && this.sort != 'num') {
          this.sort = 'num';
          this.reset();
        }
        if (this.main_show == 3 && this.sort != 'buynum') {
          this.sort = 'buynum';
          this.reset();
        }
      },
      show_poster() {
        if (!this.poster) {
          coursedetail({
            bid: 1
          }).then((data) => {
            this.imgUrl = data.sharebuy_placard;
            this.card_show = true;
            this.loading = false;
          })
        } else {
          this.card_show = true;
        }
      },
      reset() {
        this.page = 0;
        this.list = [];
        this.has_more = true;
        this.loading = false;
        this.load(0);
      },
      load(page) {
        if (this.loading) {
          return false;
        };
        this.loading = true;
        if (this.has_more) {
          if(typeof page == 'number'){
            this.page = page;
          }else {
            this.page++;
          }
          let request_page = this.page;
          let request_sort = this.sort;
          fission_index({
            page: request_page,
            sort: request_sort
          }).then((data) => {
            if(request_page == this.page && request_sort == this.sort) {
              this.list = this.list.concat(data.list);
              this.has_more = data.list.length >= this.limit;
              this.user = data.user;
              this.loading = false;
            }
          })
        }
      },
      onScroll() {
        window.onscroll = (ev) => {
          //变量scrollTop是滚动条滚动时，距离顶部的距离  
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;   //变量windowHeight是可视区的高度 
          let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;   //变量scrollHeight是滚动条的总高度   
          let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;         //滚动条到底部的条件             
          if ((scrollTop + windowHeight == scrollHeight) && this.main_show != 2) {         //写后台加载数据的函数
            this.load();       
          }  
        }
      }

    },
    created() {
      this.pullData();
    },
    mounted() {
      let tab = this.$route.query.tab;
      if (tab) {
        this.switch_tab(tab);
      };
      this.onScroll()
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bd_y {
  padding-top: changeRem(7.5)+px;
  padding-bottom: changeRem(.5)+px;
}

.top {
  width: 100%;
  background: -webkit-linear-gradient(#1d1c21, #3c3c3c);
  background: -o-linear-gradient(#1d1c21, #3c3c3c);
  background: -moz-linear-gradient(#1d1c21, #3c3c3c);
  background: linear-gradient(#1d1c21, #3c3c3c);
  padding: 0 changeRem(0.75)+px;
  padding-top: changeRem(1)+px;
  padding-bottom: changeRem(1)+px;
  position: fixed;
  top: 0;
  img.tx {
    float: right;
    width: changeRem(2.75)+px;
    height: changeRem(2.75)+px;
    border-radius: 50%;
  }
}

.top_left {
  float: left;
}

.rq {
  font-size: changeRem(0.55)+px;
  color: #feca05;
  float: left;
  margin-right: changeRem(0.25)+px;
  margin-top: changeRem(0.25)+px;
  span {
    font-size: changeRem(1.25)+px;
  }
}

.ry {
  border-left: 2px solid #616065;
  padding: changeRem(0.15)+px 0;
  padding-left: changeRem(0.2)+px;
  float: left;
  padding-top: changeRem(0.35)+px;
  h1 {
    font-size: changeRem(0.75)+px;
    color: #fff;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    display: inline-block;
    width: changeRem(7)+px;
  }
  h2 {
    font-size: changeRem(0.5)+px;
    color: #fff;
    line-height: 1;
    margin-top: changeRem(0.5)+px;
  }
}

.main_top {
  background: #fff;
  border-radius: changeRem(0.25)+px;
  padding: changeRem(0.3)+px 0;
  box-shadow: 0 changeRem(0.1)+px changeRem(0.2)+px changeRem(0.05)+px #ccc;
  position: absolute;
  bottom: changeRem(-2.25)+px;
  left: changeRem(0.75)+px;
  width: changeRem(13.5)+px;
  li {
    float: left;
    width: 33.33%;
    text-align: center;
    img {
      width: changeRem(1.25)+px;
      height: changeRem(1.25)+px;
    }
    p {
      font-size: changeRem(0.5)+px;
      color: #7a7a7a;
      margin-top: changeRem(0.3)+px;
    }
  }
  .on {
    color: #feca05;
  }
}

.main {
  width: 100%;
  padding: 0 changeRem(0.75)+px;
}

.main_bottom {
  background: #fff;
  border-radius: changeRem(0.25)+px;
  padding: 0 changeRem(0.6)+px;
  box-shadow: 0rem changeRem(0.2)+px changeRem(0.1)+px changeRem(0.05)+px #ccc;
}

.main_details {
  padding: changeRem(0.75)+px;
  h1 {
    color: #333;
    font-size: 38px;
  }
  h2 {
    color: #F57F17;
    font-size: 38px;
    margin-top: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
  }
  p {
    font-size: changeRem(0.7)+px;
    color: #7a7a7a;
    line-height: changeRem(0.95)+px;
    margin-top: changeRem(0.75)+px;
  }
  img {
    width: 100%;
    margin-top: changeRem(0.5)+px;
  }
}
.main_ranking {
  margin-top: 40px;
}
.main_ranking li {
  border-bottom: 2px solid #dadada;
  padding: changeRem(0.25)+px 0;
  .rank_ll {
    width: changeRem(1.6)+px;
    display: inline-block;
    text-align: center;
    font-size: changeRem(0.55)+px;
    color: #f9820d;
    vertical-align: middle;
    img {
      width: changeRem(1)+px;
      height: changeRem(1)+px;
      vertical-align: middle;
    }
  }
  .rank_me {
    font-weight: bold;
  }
  img.xtx {
    width: changeRem(1)+px;
    height: changeRem(1)+px;
    margin: 0 changeRem(0.35)+px;
    vertical-align: middle;
    border-radius: 50%;
    margin-left: 0;
  }
  span.rank_name {
    font-size: changeRem(0.55)+px;
    color: #f9820d;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    display: inline-block;
    width: changeRem(5.5)+px;
    vertical-align: bottom;
  }
  span.rank_right {
    float: right;
    color: #f9500d;
    font-size: changeRem(0.55)+px;
    line-height: changeRem(1.1)+px;
  }
}

.jc {
  padding-top: 50px;
  text-align: center;
  color: #7a7a7a;
}

// 弹出卡片
.pop_card {
  background-color: transparent;
  text-align: center;
  img {
    width: changeRem(12)+px;
  }
  h3 {
    margin-top: changeRem(.8)+px;
    line-height: 1;
    color: #fff;
    font-size: changeRem(.52)+px;
    background-color: transparent;
  }
}
</style>
